<script setup lang="ts">
    import AcademyTrainingsCarouselClientContent from './AcademyTrainingsCarouselClientContent.vue';
    import AcademyTrainingsCarouselView from './AcademyTrainingsCarouselView.vue';
    import { useAcademyManualTrainings } from '~/composables/useAcademyManualTrainings';

    const {
        courseIds,
        headline = '',
        noResultsMessage
    } = defineProps<{
        courseIds: number[];
        headline?: string;
        noResultsMessage: string;
    }>();

    const { isAuthenticated, canFetch, items, isInitialLoading, prettyError, showNoResults } =
        useAcademyManualTrainings(() => courseIds);
    const { isDraftModeEnabled } = useDraftMode();
</script>

<template>
    <Note
        v-if="isDraftModeEnabled && !isAuthenticated"
        type="warning"
    >
        {{ $t('academy.relatedTrainings.previewLoginRequired') }}
    </Note>
    <AcademyTrainingsCarouselView
        v-else-if="canFetch"
        :headline="headline"
    >
        <template
            v-if="$slots.teaser"
            #teaser
        >
            <slot name="teaser" />
        </template>

        <AcademyTrainingsCarouselClientContent
            :is-initial-loading="isInitialLoading"
            :pretty-error="prettyError"
            :items="items"
            :show-no-results="showNoResults"
            :no-results-message="noResultsMessage"
        />

        <template
            v-if="$slots.link"
            #link
        >
            <slot name="link" />
        </template>
    </AcademyTrainingsCarouselView>
</template>
